import { Link } from 'react-router-dom'
import { Container } from './style'
// @ts-ignore
import imgLogo from '../../assets/img/logo.svg'
import UserDropdown from '../UserDropdown'
import { useProvider } from '../../provider/Provider'

const Header = () => {
    const { authenticated } = useProvider()

    return (
        <Container>
            <div className="container">
                <div className="row">
                    <nav
                        className="navbar fixed-top
                            navbar-expand-lg navbar-dark animate"
                        data-anime="top"
                    >
                        <div className="container" id="idContainer">
                            <Link to="/">
                                <img
                                    src={imgLogo}
                                    width="190"
                                    height="40"
                                    alt="Logo da Conectaê."
                                />
                            </Link>
                            <button
                                className="navbar-toggler collapsed"
                                type="button"
                                data-toggle="collapse"
                                data-target="#navbarSupportedContent"
                                aria-controls="navbarSupportedContent"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                            >
                                <span className="navbar-toggler-icon">
                                    <i className="fa fa-navicon" />
                                </span>
                            </button>
                            <div
                                className="navbar-collapse menu collapse"
                                id="navbarSupportedContent"
                            >
                                <ul className="navbar-nav ml-auto mt-2 mt-lg-0">
                                    <li className="nav-item mx-2">
                                        <Link
                                            className="nav-link"
                                            to="/buscar"
                                        >
                                            Buscar
                                        </Link>
                                    </li>
                                    <li
                                        className={
                                            authenticated
                                                ? 'nav-item mx-2'
                                                : 'nav-item mx-2 hidden'
                                        }
                                    >
                                        <Link
                                            className="nav-link"
                                            to="/cadastrar"
                                        >
                                            Cadastrar
                                        </Link>
                                    </li>
                                    <li className="nav-item mx-2">
                                        <Link
                                            className="nav-link"
                                            to="/dados-ecossistema"
                                        >
                                            Dados do Ecossistema
                                        </Link>
                                    </li>
                                    <UserDropdown />
                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </Container>
    )
}

export default Header
